import c1 from "assets/images/posts/c1.jpg";
import c2 from "assets/images/posts/c2.jpg";
import c3 from "assets/images/posts/c3.jpg";
import ImagePollItem from "./ImagePollItem";

const PostImagePoll = () => {
    return (
        <div className="post-image-poll-wrapper flex justify-center items-start gap-5 gap-3 py-4">
            <ImagePollItem img={c1} percent={25} />
            <ImagePollItem img={c2} percent={35} />
            <ImagePollItem img={c3} percent={40} />
        </div>
    );
};

export default PostImagePoll;
